import React, { useEffect, useState } from "react";
import { Loader2, Ship } from "lucide-react";
import { toast } from "sonner";
import { Modal, reviewsApi, inputCls, btnCls, fmtDate } from "./shared";

export default function AssignModal({ review, garsonlar, onClose, onDone }) {
  const [garson, setGarson] = useState("");
  const [salon, setSalon] = useState("");
  const [masa, setMasa] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!review) return;
    setGarson(review.garson || ""); setSalon(review.salon || ""); setMasa(review.masa || "");
  }, [review]);

  if (!review) return null;
  const names = [...new Set([...(garsonlar || []).map(g => (g.name || "").toUpperCase()), ...(review.garson ? [review.garson] : [])])].filter(Boolean).sort();

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const d = await reviewsApi.assign(review.id, { garson, salon, masa });
      const n = Object.keys(d.changed || {}).length;
      toast.success(n ? "Rezervasyon satırı güncellendi — Canlı Sayfa'ya yansıdı" : "Değişiklik yok");
      onDone();
    } catch (err) { toast.error(err?.response?.data?.detail || "Kaydedilemedi"); }
    setSaving(false);
  };

  return (
    <Modal open onClose={onClose} title="Rezervasyonu Düzenle — Garson / Salon / Masa" testId="assign-modal">
      <div className="mb-4 text-xs text-slate-400 bg-slate-800/70 border border-slate-700 rounded-lg p-3 flex flex-wrap gap-x-4 gap-y-1">
        <span className="text-slate-200 font-medium">{review.customer_name || review.reviewer_name}</span>
        <span className="font-mono text-sky-300">{review.confirmation_code}</span>
        <span>{fmtDate(review.booking_date)} {review.booking_time?.slice(0, 5)}</span>
        {review.boat_name && <span className="inline-flex items-center gap-1 text-cyan-300"><Ship className="w-3 h-3" />{review.boat_name}</span>}
        <span>{review.total_pax} pax</span>
      </div>
      <form onSubmit={submit} className="space-y-3">
        <label className="text-xs text-slate-400 block">Garson
          <input list="assign-garson-list" value={garson} onChange={e => setGarson(e.target.value.toUpperCase())} placeholder="Garson seçin veya yazın" className={`${inputCls} w-full mt-1`} data-testid="assign-garson" />
          <datalist id="assign-garson-list">{names.map(n => <option key={n} value={n} />)}</datalist>
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs text-slate-400">Kat / Salon
            <input value={salon} onChange={e => setSalon(e.target.value)} placeholder="1KAT" className={`${inputCls} w-full mt-1`} data-testid="assign-salon" />
          </label>
          <label className="text-xs text-slate-400">Masa
            <input value={masa} onChange={e => setMasa(e.target.value)} placeholder="12" className={`${inputCls} w-full mt-1`} data-testid="assign-masa" />
          </label>
        </div>
        <p className="text-[11px] text-slate-500">Bu alanlar Canlı Sayfa'daki rezervasyon satırına yazılır ve Kullanıcı Geçmişi'ne işlenir.</p>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" onClick={onClose} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200`} data-testid="assign-cancel-btn">Vazgeç</button>
          <button type="submit" disabled={saving} className={`${btnCls} bg-blue-600 hover:bg-blue-500 text-white`} data-testid="assign-submit-btn">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Kaydet
          </button>
        </div>
      </form>
    </Modal>
  );
}
